<template>
  <div class="syotei-work-month-times edit-item" v-if="editingData && options">

    <div class="head"><b>所定労働時間（月）</b></div>
    <div class="data flex flex-align-center">
      <div class="hours">
        <input-text v-model="editingData.syotei_work_month_times" :type="'number'" inputmode="numeric" class="small" min="0"
          :error="getError(editingData, 'syotei_work_month_times')" :disabled="disabled"></input-text>
        <p class="current-data" v-if="currentData?.syotei_work_month_times">{{ currentData.syotei_work_month_times }}
        </p>
      </div>
      <p class="scale">時間</p>
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError,
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
